import { put, call, takeLatest, take } from "redux-saga/effects";
import { consume } from "../api";
import { OperationActions, OperationTypes, ISubirArchivos, IDesencriptarPrestadorStart } from "../../consts/OperationTypes";
import { TablaTypes } from "../../consts/TablaTypes";
import { ModalTypes } from "../../consts/ModalTypes";

export function* desencriptarPrestador(action: OperationActions) {
  try {
    const { payload: p } = action as IDesencriptarPrestadorStart;
    const response = yield call(
      consume,
      `desencriptarHTMLService/${p}`,
      null,
      null,
      "GET"
    );
    yield put({
      type: OperationTypes.SUCCESS,
      payload: {
        prestador: response.data.valor,
        valorEncriptado: p,
      },
    });
    sessionStorage.setItem('accessToken', p);
  } catch (error) {
    yield put({ type: OperationTypes.ERROR, payload: { error } });
  }
}

export function* subirArchivos({ payload } : OperationActions) {
  const body = payload as ISubirArchivos;
  try {
    yield call(
      consume,
      "archivos",
      body.fd,
      { "content-type": "multipart/form-data" },
      "POST"
    );
    yield put({
      type: OperationTypes.CARGAR_ARCHIVOS_SUCCESS,
      payload: { archivosSubidos: body.archivos },
    });
  } catch (error) {
    yield put({
      type: OperationTypes.CARGAR_ARCHIVOS_ERROR,
      payload: {error:error.message},
    });
  }
}

export function* onUploadError() {
  yield take(OperationTypes.CARGAR_ARCHIVOS_ERROR);
  yield put({ type: TablaTypes.LIMPIAR_ADJUNTOS });
  yield put({
    type: ModalTypes.HANDLE_MODAL_NOTIFICACION,
    payload: {
      open: true,
      currDesc: "Hubo un error al intentar subir los archivos",
    },
  });
}

export function* onUploadSuccess() {
  yield take(OperationTypes.CARGAR_ARCHIVOS_SUCCESS);
  yield put({ type: TablaTypes.LIMPIAR_ADJUNTOS });
  yield put({
    type: ModalTypes.HANDLE_MODAL_NOTIFICACION,
    payload: {
      open: true,
      currDesc:
        "Los archivos se subieron con éxito!, dentro de los próximos 10 días hábiles luego de haber subido la facturación podrá verificar en LIQUIDACIONES Y PAGOS",
    },
  });
}

export default function* operationsSagas() {
  yield takeLatest(OperationTypes.START, desencriptarPrestador);
  yield takeLatest(OperationTypes.CARGAR_ARCHIVOS_START, subirArchivos);
  yield takeLatest(OperationTypes.CARGAR_ARCHIVOS_START, onUploadError);
  yield takeLatest(OperationTypes.CARGAR_ARCHIVOS_START, onUploadSuccess);
}
